import { SESSION_STORAGE_KEYS } from './sessionStorage';
import type { MimirStage } from '@mimir/common/deployment/stageData';
import { LOCAL_STORAGE } from './constants';
import { isMimirStage } from '@mimir/common/deployment/stages';
import { getRememberMeGlobalLogin } from './localStorage';

/**
 * These URLs are obtained based on the global sign in configuration.
 * i.e getDefaultGlobalTableConfig() and cloudfront
 */
const VALID_GLOBAL_LOGIN_URLS: ReadonlySet<string> = new Set([
  'mimir.media', // production
  'd1zr9q2i6ms1ct.cloudfront.net', // research2
  'dyrjrmjlwzhnq.cloudfront.net', // research3
  'dzxh6hk8ibaob.cloudfront.net', // research5
  'd1npqm2pw59b2o.cloudfront.net', // research6
  'd2ebb8lbxbsx60.cloudfront.net', // research7
  'd1eprop968t8pg.cloudfront.net', // research8
  'd2m5jog3m8htnc.cloudfront.net', // research9
  'd2nc6qgplv9dv.cloudfront.net', // dev
  'd221vfoicvr16x.cloudfront.net', // qa1
  'd2h1vnrwk962zj.cloudfront.net', // qa2
  'd16zma810hp7dl.cloudfront.net', // qa3
  'ds37f8ofxasv9.cloudfront.net', // qa4
  'd1qn0nba009kxq.cloudfront.net' // qa5
]);

export const validateComingFromStageQueryValue = (url: string): boolean => {
  return VALID_GLOBAL_LOGIN_URLS.has(url);
};

export const clearLocalStorageGlobalLoginData = () => {
  localStorage.removeItem(LOCAL_STORAGE.LAST_SELECTED_STAGE_GLOBAL_LOGIN);
  localStorage.removeItem(LOCAL_STORAGE.LAST_ENTERED_IDENTITY_GLOBAL_LOGIN);
};

export const getLastEnteredGlobalLoginIdentity = (): string | null => {
  const sessionIdentity = sessionStorage.getItem(SESSION_STORAGE_KEYS.LAST_ENTERED_IDENTITY_GLOBAL_LOGIN);
  if (sessionIdentity) {
    return sessionIdentity;
  }
  return localStorage.getItem(LOCAL_STORAGE.LAST_ENTERED_IDENTITY_GLOBAL_LOGIN);
};

export const getStoredIdentityAndStage = (): { stage: MimirStage, identity: string } | null => {
  const sessionIdentity = sessionStorage.getItem(SESSION_STORAGE_KEYS.LAST_ENTERED_IDENTITY_GLOBAL_LOGIN);
  const sessionStage = sessionStorage.getItem(SESSION_STORAGE_KEYS.LAST_SELECTED_STAGE_GLOBAL_LOGIN);
  if (sessionIdentity && sessionStage && isMimirStage(sessionStage)) {
    return { identity: sessionIdentity, stage: sessionStage };
  }

  const localIdentity = localStorage.getItem(LOCAL_STORAGE.LAST_ENTERED_IDENTITY_GLOBAL_LOGIN);
  const localStage = localStorage.getItem(LOCAL_STORAGE.LAST_SELECTED_STAGE_GLOBAL_LOGIN);
  if (localIdentity && localStage && isMimirStage(localStage)) {
    return { identity: localIdentity, stage: localStage };
  }

  return null;
};

export const setIdentityAndStageInStorage = (identity: string, stage: MimirStage) => {
  sessionStorage.setItem(SESSION_STORAGE_KEYS.LAST_ENTERED_IDENTITY_GLOBAL_LOGIN, identity);
  sessionStorage.setItem(SESSION_STORAGE_KEYS.LAST_SELECTED_STAGE_GLOBAL_LOGIN, stage);

  const rememberMeState = getRememberMeGlobalLogin();
  if (rememberMeState) {
    localStorage.setItem(LOCAL_STORAGE.LAST_ENTERED_IDENTITY_GLOBAL_LOGIN, identity);
    localStorage.setItem(LOCAL_STORAGE.LAST_SELECTED_STAGE_GLOBAL_LOGIN, stage);
  } else {
    clearLocalStorageGlobalLoginData();
  }
};

export const clearSessionStorageGlobalLoginData = (): void => {
  sessionStorage.removeItem(SESSION_STORAGE_KEYS.LAST_ENTERED_IDENTITY_GLOBAL_LOGIN);
  sessionStorage.removeItem(SESSION_STORAGE_KEYS.LAST_SELECTED_STAGE_GLOBAL_LOGIN);
};
